// source: pbtypes/vehicle/global_planner/global_planner_client.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_motion_manager_frames_pb = require('../../../pbtypes/vehicle/motion_manager/frames_pb.js');
goog.object.extend(proto, pbtypes_vehicle_motion_manager_frames_pb);
goog.exportSymbol('proto.global_planner.BacktrackingArgs', null, global);
goog.exportSymbol('proto.global_planner.Client', null, global);
goog.exportSymbol('proto.global_planner.Client.Enum', null, global);
goog.exportSymbol('proto.global_planner.DirectPathArgs', null, global);
goog.exportSymbol('proto.global_planner.GlobalPlannerRequest', null, global);
goog.exportSymbol('proto.global_planner.ObstructionBehaviorType', null, global);
goog.exportSymbol('proto.global_planner.ObstructionBehaviorType.Enum', null, global);
goog.exportSymbol('proto.global_planner.PathfinderArgs', null, global);
goog.exportSymbol('proto.global_planner.RequestKey', null, global);
goog.exportSymbol('proto.global_planner.RequestSegment', null, global);
goog.exportSymbol('proto.global_planner.RequestSegment.BackendArgsCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.GlobalPlannerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.global_planner.GlobalPlannerRequest.repeatedFields_, null);
};
goog.inherits(proto.global_planner.GlobalPlannerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.GlobalPlannerRequest.displayName = 'proto.global_planner.GlobalPlannerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.RequestKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.RequestKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.RequestKey.displayName = 'proto.global_planner.RequestKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.Client.displayName = 'proto.global_planner.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.RequestSegment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.global_planner.RequestSegment.oneofGroups_);
};
goog.inherits(proto.global_planner.RequestSegment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.RequestSegment.displayName = 'proto.global_planner.RequestSegment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.ObstructionBehaviorType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.ObstructionBehaviorType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.ObstructionBehaviorType.displayName = 'proto.global_planner.ObstructionBehaviorType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.DirectPathArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.DirectPathArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.DirectPathArgs.displayName = 'proto.global_planner.DirectPathArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.PathfinderArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.PathfinderArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.PathfinderArgs.displayName = 'proto.global_planner.PathfinderArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.global_planner.BacktrackingArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.global_planner.BacktrackingArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.global_planner.BacktrackingArgs.displayName = 'proto.global_planner.BacktrackingArgs';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.global_planner.GlobalPlannerRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.GlobalPlannerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.GlobalPlannerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.GlobalPlannerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.GlobalPlannerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
requestKey: (f = msg.getRequestKey()) && proto.global_planner.RequestKey.toObject(includeInstance, f),
startPosition: (f = msg.getStartPosition()) && pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.toObject(includeInstance, f),
pathSegmentsList: jspb.Message.toObjectList(msg.getPathSegmentsList(),
    proto.global_planner.RequestSegment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.GlobalPlannerRequest}
 */
proto.global_planner.GlobalPlannerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.GlobalPlannerRequest;
  return proto.global_planner.GlobalPlannerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.GlobalPlannerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.GlobalPlannerRequest}
 */
proto.global_planner.GlobalPlannerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new proto.global_planner.RequestKey;
      reader.readMessage(value,proto.global_planner.RequestKey.deserializeBinaryFromReader);
      msg.setRequestKey(value);
      break;
    case 3:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.deserializeBinaryFromReader);
      msg.setStartPosition(value);
      break;
    case 4:
      var value = new proto.global_planner.RequestSegment;
      reader.readMessage(value,proto.global_planner.RequestSegment.deserializeBinaryFromReader);
      msg.addPathSegments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.GlobalPlannerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.GlobalPlannerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.GlobalPlannerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.GlobalPlannerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRequestKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.global_planner.RequestKey.serializeBinaryToWriter
    );
  }
  f = message.getStartPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.serializeBinaryToWriter
    );
  }
  f = message.getPathSegmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.global_planner.RequestSegment.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.global_planner.GlobalPlannerRequest.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
 */
proto.global_planner.GlobalPlannerRequest.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional RequestKey request_key = 2;
 * @return {?proto.global_planner.RequestKey}
 */
proto.global_planner.GlobalPlannerRequest.prototype.getRequestKey = function() {
  return /** @type{?proto.global_planner.RequestKey} */ (
    jspb.Message.getWrapperField(this, proto.global_planner.RequestKey, 2));
};


/**
 * @param {?proto.global_planner.RequestKey|undefined} value
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
*/
proto.global_planner.GlobalPlannerRequest.prototype.setRequestKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
 */
proto.global_planner.GlobalPlannerRequest.prototype.clearRequestKey = function() {
  return this.setRequestKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.GlobalPlannerRequest.prototype.hasRequestKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional motion_manager.FramedXYZPb start_position = 3;
 * @return {?proto.motion_manager.FramedXYZPb}
 */
proto.global_planner.GlobalPlannerRequest.prototype.getStartPosition = function() {
  return /** @type{?proto.motion_manager.FramedXYZPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb, 3));
};


/**
 * @param {?proto.motion_manager.FramedXYZPb|undefined} value
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
*/
proto.global_planner.GlobalPlannerRequest.prototype.setStartPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
 */
proto.global_planner.GlobalPlannerRequest.prototype.clearStartPosition = function() {
  return this.setStartPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.GlobalPlannerRequest.prototype.hasStartPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RequestSegment path_segments = 4;
 * @return {!Array<!proto.global_planner.RequestSegment>}
 */
proto.global_planner.GlobalPlannerRequest.prototype.getPathSegmentsList = function() {
  return /** @type{!Array<!proto.global_planner.RequestSegment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.global_planner.RequestSegment, 4));
};


/**
 * @param {!Array<!proto.global_planner.RequestSegment>} value
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
*/
proto.global_planner.GlobalPlannerRequest.prototype.setPathSegmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.global_planner.RequestSegment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.global_planner.RequestSegment}
 */
proto.global_planner.GlobalPlannerRequest.prototype.addPathSegments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.global_planner.RequestSegment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.global_planner.GlobalPlannerRequest} returns this
 */
proto.global_planner.GlobalPlannerRequest.prototype.clearPathSegmentsList = function() {
  return this.setPathSegmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.RequestKey.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.RequestKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.RequestKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.RequestKey.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, 0),
requestId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.RequestKey}
 */
proto.global_planner.RequestKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.RequestKey;
  return proto.global_planner.RequestKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.RequestKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.RequestKey}
 */
proto.global_planner.RequestKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.global_planner.Client.Enum} */ (reader.readEnum());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.RequestKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.RequestKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.RequestKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.RequestKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional Client.Enum client_id = 1;
 * @return {!proto.global_planner.Client.Enum}
 */
proto.global_planner.RequestKey.prototype.getClientId = function() {
  return /** @type {!proto.global_planner.Client.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.global_planner.Client.Enum} value
 * @return {!proto.global_planner.RequestKey} returns this
 */
proto.global_planner.RequestKey.prototype.setClientId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 request_id = 2;
 * @return {number}
 */
proto.global_planner.RequestKey.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.RequestKey} returns this
 */
proto.global_planner.RequestKey.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.Client.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.Client}
 */
proto.global_planner.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.Client;
  return proto.global_planner.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.Client}
 */
proto.global_planner.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.global_planner.Client.Enum = {
  INVALID: 0,
  MOTION_MANAGER: 1,
  RETURN_MANAGER: 2
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.global_planner.RequestSegment.oneofGroups_ = [[5,6,7]];

/**
 * @enum {number}
 */
proto.global_planner.RequestSegment.BackendArgsCase = {
  BACKEND_ARGS_NOT_SET: 0,
  DIRECT_PATH: 5,
  PATHFINDER_ARGS: 6,
  BACKTRACKING_ARGS: 7
};

/**
 * @return {proto.global_planner.RequestSegment.BackendArgsCase}
 */
proto.global_planner.RequestSegment.prototype.getBackendArgsCase = function() {
  return /** @type {proto.global_planner.RequestSegment.BackendArgsCase} */(jspb.Message.computeOneofCase(this, proto.global_planner.RequestSegment.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.RequestSegment.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.RequestSegment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.RequestSegment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.RequestSegment.toObject = function(includeInstance, msg) {
  var f, obj = {
segmentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
targetPosition: (f = msg.getTargetPosition()) && pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.toObject(includeInstance, f),
desiredXySpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
desiredZSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
directPath: (f = msg.getDirectPath()) && proto.global_planner.DirectPathArgs.toObject(includeInstance, f),
pathfinderArgs: (f = msg.getPathfinderArgs()) && proto.global_planner.PathfinderArgs.toObject(includeInstance, f),
backtrackingArgs: (f = msg.getBacktrackingArgs()) && proto.global_planner.BacktrackingArgs.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.RequestSegment}
 */
proto.global_planner.RequestSegment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.RequestSegment;
  return proto.global_planner.RequestSegment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.RequestSegment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.RequestSegment}
 */
proto.global_planner.RequestSegment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSegmentId(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.deserializeBinaryFromReader);
      msg.setTargetPosition(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDesiredXySpeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDesiredZSpeed(value);
      break;
    case 5:
      var value = new proto.global_planner.DirectPathArgs;
      reader.readMessage(value,proto.global_planner.DirectPathArgs.deserializeBinaryFromReader);
      msg.setDirectPath(value);
      break;
    case 6:
      var value = new proto.global_planner.PathfinderArgs;
      reader.readMessage(value,proto.global_planner.PathfinderArgs.deserializeBinaryFromReader);
      msg.setPathfinderArgs(value);
      break;
    case 7:
      var value = new proto.global_planner.BacktrackingArgs;
      reader.readMessage(value,proto.global_planner.BacktrackingArgs.deserializeBinaryFromReader);
      msg.setBacktrackingArgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.RequestSegment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.RequestSegment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.RequestSegment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.RequestSegment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegmentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTargetPosition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb.serializeBinaryToWriter
    );
  }
  f = message.getDesiredXySpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDesiredZSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDirectPath();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.global_planner.DirectPathArgs.serializeBinaryToWriter
    );
  }
  f = message.getPathfinderArgs();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.global_planner.PathfinderArgs.serializeBinaryToWriter
    );
  }
  f = message.getBacktrackingArgs();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.global_planner.BacktrackingArgs.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 segment_id = 1;
 * @return {number}
 */
proto.global_planner.RequestSegment.prototype.getSegmentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.setSegmentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional motion_manager.FramedXYZPb target_position = 2;
 * @return {?proto.motion_manager.FramedXYZPb}
 */
proto.global_planner.RequestSegment.prototype.getTargetPosition = function() {
  return /** @type{?proto.motion_manager.FramedXYZPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.FramedXYZPb, 2));
};


/**
 * @param {?proto.motion_manager.FramedXYZPb|undefined} value
 * @return {!proto.global_planner.RequestSegment} returns this
*/
proto.global_planner.RequestSegment.prototype.setTargetPosition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.clearTargetPosition = function() {
  return this.setTargetPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.RequestSegment.prototype.hasTargetPosition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double desired_xy_speed = 3;
 * @return {number}
 */
proto.global_planner.RequestSegment.prototype.getDesiredXySpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.setDesiredXySpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double desired_z_speed = 4;
 * @return {number}
 */
proto.global_planner.RequestSegment.prototype.getDesiredZSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.setDesiredZSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional DirectPathArgs direct_path = 5;
 * @return {?proto.global_planner.DirectPathArgs}
 */
proto.global_planner.RequestSegment.prototype.getDirectPath = function() {
  return /** @type{?proto.global_planner.DirectPathArgs} */ (
    jspb.Message.getWrapperField(this, proto.global_planner.DirectPathArgs, 5));
};


/**
 * @param {?proto.global_planner.DirectPathArgs|undefined} value
 * @return {!proto.global_planner.RequestSegment} returns this
*/
proto.global_planner.RequestSegment.prototype.setDirectPath = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.global_planner.RequestSegment.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.clearDirectPath = function() {
  return this.setDirectPath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.RequestSegment.prototype.hasDirectPath = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PathfinderArgs pathfinder_args = 6;
 * @return {?proto.global_planner.PathfinderArgs}
 */
proto.global_planner.RequestSegment.prototype.getPathfinderArgs = function() {
  return /** @type{?proto.global_planner.PathfinderArgs} */ (
    jspb.Message.getWrapperField(this, proto.global_planner.PathfinderArgs, 6));
};


/**
 * @param {?proto.global_planner.PathfinderArgs|undefined} value
 * @return {!proto.global_planner.RequestSegment} returns this
*/
proto.global_planner.RequestSegment.prototype.setPathfinderArgs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.global_planner.RequestSegment.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.clearPathfinderArgs = function() {
  return this.setPathfinderArgs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.RequestSegment.prototype.hasPathfinderArgs = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional BacktrackingArgs backtracking_args = 7;
 * @return {?proto.global_planner.BacktrackingArgs}
 */
proto.global_planner.RequestSegment.prototype.getBacktrackingArgs = function() {
  return /** @type{?proto.global_planner.BacktrackingArgs} */ (
    jspb.Message.getWrapperField(this, proto.global_planner.BacktrackingArgs, 7));
};


/**
 * @param {?proto.global_planner.BacktrackingArgs|undefined} value
 * @return {!proto.global_planner.RequestSegment} returns this
*/
proto.global_planner.RequestSegment.prototype.setBacktrackingArgs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.global_planner.RequestSegment.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.RequestSegment} returns this
 */
proto.global_planner.RequestSegment.prototype.clearBacktrackingArgs = function() {
  return this.setBacktrackingArgs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.RequestSegment.prototype.hasBacktrackingArgs = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.ObstructionBehaviorType.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.ObstructionBehaviorType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.ObstructionBehaviorType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.ObstructionBehaviorType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.ObstructionBehaviorType}
 */
proto.global_planner.ObstructionBehaviorType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.ObstructionBehaviorType;
  return proto.global_planner.ObstructionBehaviorType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.ObstructionBehaviorType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.ObstructionBehaviorType}
 */
proto.global_planner.ObstructionBehaviorType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.ObstructionBehaviorType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.ObstructionBehaviorType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.ObstructionBehaviorType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.ObstructionBehaviorType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.global_planner.ObstructionBehaviorType.Enum = {
  IGNORE: 0,
  PLAN_AROUND: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.DirectPathArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.DirectPathArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.DirectPathArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.DirectPathArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
traversalHeight: (f = msg.getTraversalHeight()) && pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.toObject(includeInstance, f),
startRampAngle: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
endRampAngle: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
geofenceBehavior: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.DirectPathArgs}
 */
proto.global_planner.DirectPathArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.DirectPathArgs;
  return proto.global_planner.DirectPathArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.DirectPathArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.DirectPathArgs}
 */
proto.global_planner.DirectPathArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.deserializeBinaryFromReader);
      msg.setTraversalHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartRampAngle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEndRampAngle(value);
      break;
    case 2:
      var value = /** @type {!proto.global_planner.ObstructionBehaviorType.Enum} */ (reader.readEnum());
      msg.setGeofenceBehavior(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.DirectPathArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.DirectPathArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.DirectPathArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.DirectPathArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTraversalHeight();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getGeofenceBehavior();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional motion_manager.FramedScalarPb traversal_height = 1;
 * @return {?proto.motion_manager.FramedScalarPb}
 */
proto.global_planner.DirectPathArgs.prototype.getTraversalHeight = function() {
  return /** @type{?proto.motion_manager.FramedScalarPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb, 1));
};


/**
 * @param {?proto.motion_manager.FramedScalarPb|undefined} value
 * @return {!proto.global_planner.DirectPathArgs} returns this
*/
proto.global_planner.DirectPathArgs.prototype.setTraversalHeight = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.clearTraversalHeight = function() {
  return this.setTraversalHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.DirectPathArgs.prototype.hasTraversalHeight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double start_ramp_angle = 3;
 * @return {number}
 */
proto.global_planner.DirectPathArgs.prototype.getStartRampAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.setStartRampAngle = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.clearStartRampAngle = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.DirectPathArgs.prototype.hasStartRampAngle = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double end_ramp_angle = 4;
 * @return {number}
 */
proto.global_planner.DirectPathArgs.prototype.getEndRampAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.setEndRampAngle = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.clearEndRampAngle = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.DirectPathArgs.prototype.hasEndRampAngle = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ObstructionBehaviorType.Enum geofence_behavior = 2;
 * @return {!proto.global_planner.ObstructionBehaviorType.Enum}
 */
proto.global_planner.DirectPathArgs.prototype.getGeofenceBehavior = function() {
  return /** @type {!proto.global_planner.ObstructionBehaviorType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.global_planner.ObstructionBehaviorType.Enum} value
 * @return {!proto.global_planner.DirectPathArgs} returns this
 */
proto.global_planner.DirectPathArgs.prototype.setGeofenceBehavior = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.PathfinderArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.PathfinderArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.PathfinderArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.PathfinderArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
traversalHeight: (f = msg.getTraversalHeight()) && pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.toObject(includeInstance, f),
startRampAngle: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
endRampAngle: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.PathfinderArgs}
 */
proto.global_planner.PathfinderArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.PathfinderArgs;
  return proto.global_planner.PathfinderArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.PathfinderArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.PathfinderArgs}
 */
proto.global_planner.PathfinderArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.deserializeBinaryFromReader);
      msg.setTraversalHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartRampAngle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEndRampAngle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.PathfinderArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.PathfinderArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.PathfinderArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.PathfinderArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTraversalHeight();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional motion_manager.FramedScalarPb traversal_height = 1;
 * @return {?proto.motion_manager.FramedScalarPb}
 */
proto.global_planner.PathfinderArgs.prototype.getTraversalHeight = function() {
  return /** @type{?proto.motion_manager.FramedScalarPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.FramedScalarPb, 1));
};


/**
 * @param {?proto.motion_manager.FramedScalarPb|undefined} value
 * @return {!proto.global_planner.PathfinderArgs} returns this
*/
proto.global_planner.PathfinderArgs.prototype.setTraversalHeight = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.PathfinderArgs} returns this
 */
proto.global_planner.PathfinderArgs.prototype.clearTraversalHeight = function() {
  return this.setTraversalHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.PathfinderArgs.prototype.hasTraversalHeight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double start_ramp_angle = 2;
 * @return {number}
 */
proto.global_planner.PathfinderArgs.prototype.getStartRampAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.PathfinderArgs} returns this
 */
proto.global_planner.PathfinderArgs.prototype.setStartRampAngle = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.global_planner.PathfinderArgs} returns this
 */
proto.global_planner.PathfinderArgs.prototype.clearStartRampAngle = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.PathfinderArgs.prototype.hasStartRampAngle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double end_ramp_angle = 3;
 * @return {number}
 */
proto.global_planner.PathfinderArgs.prototype.getEndRampAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.global_planner.PathfinderArgs} returns this
 */
proto.global_planner.PathfinderArgs.prototype.setEndRampAngle = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.global_planner.PathfinderArgs} returns this
 */
proto.global_planner.PathfinderArgs.prototype.clearEndRampAngle = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.PathfinderArgs.prototype.hasEndRampAngle = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.global_planner.BacktrackingArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.global_planner.BacktrackingArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.global_planner.BacktrackingArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.BacktrackingArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
outputFrameXy: (f = msg.getOutputFrameXy()) && pbtypes_vehicle_motion_manager_frames_pb.Frame.toObject(includeInstance, f),
outputFrameZ: (f = msg.getOutputFrameZ()) && pbtypes_vehicle_motion_manager_frames_pb.Frame.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.global_planner.BacktrackingArgs}
 */
proto.global_planner.BacktrackingArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.global_planner.BacktrackingArgs;
  return proto.global_planner.BacktrackingArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.global_planner.BacktrackingArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.global_planner.BacktrackingArgs}
 */
proto.global_planner.BacktrackingArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.Frame;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.Frame.deserializeBinaryFromReader);
      msg.setOutputFrameXy(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_motion_manager_frames_pb.Frame;
      reader.readMessage(value,pbtypes_vehicle_motion_manager_frames_pb.Frame.deserializeBinaryFromReader);
      msg.setOutputFrameZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.global_planner.BacktrackingArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.global_planner.BacktrackingArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.global_planner.BacktrackingArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.global_planner.BacktrackingArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutputFrameXy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.Frame.serializeBinaryToWriter
    );
  }
  f = message.getOutputFrameZ();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_motion_manager_frames_pb.Frame.serializeBinaryToWriter
    );
  }
};


/**
 * optional motion_manager.Frame output_frame_xy = 1;
 * @return {?proto.motion_manager.Frame}
 */
proto.global_planner.BacktrackingArgs.prototype.getOutputFrameXy = function() {
  return /** @type{?proto.motion_manager.Frame} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.Frame, 1));
};


/**
 * @param {?proto.motion_manager.Frame|undefined} value
 * @return {!proto.global_planner.BacktrackingArgs} returns this
*/
proto.global_planner.BacktrackingArgs.prototype.setOutputFrameXy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.BacktrackingArgs} returns this
 */
proto.global_planner.BacktrackingArgs.prototype.clearOutputFrameXy = function() {
  return this.setOutputFrameXy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.BacktrackingArgs.prototype.hasOutputFrameXy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional motion_manager.Frame output_frame_z = 2;
 * @return {?proto.motion_manager.Frame}
 */
proto.global_planner.BacktrackingArgs.prototype.getOutputFrameZ = function() {
  return /** @type{?proto.motion_manager.Frame} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_motion_manager_frames_pb.Frame, 2));
};


/**
 * @param {?proto.motion_manager.Frame|undefined} value
 * @return {!proto.global_planner.BacktrackingArgs} returns this
*/
proto.global_planner.BacktrackingArgs.prototype.setOutputFrameZ = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.global_planner.BacktrackingArgs} returns this
 */
proto.global_planner.BacktrackingArgs.prototype.clearOutputFrameZ = function() {
  return this.setOutputFrameZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.global_planner.BacktrackingArgs.prototype.hasOutputFrameZ = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.global_planner);
